<div class="mt-4">
    <app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
    <form [formGroup]="formulario">
        <div class="d-flex justify-content-center mt-4">
            <div class="d-flex col-md-6 mt-2 me-5">
                <label class="mt-1 me-3">Nombre</label>
                <input type="text"[(ngModel)]="nombreAplicacion" placeholder="Nombre del aplicativo" class="form-control" formControlName="Nombre">
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <span *ngIf="nombreObligatorio" class="text-danger">
                {{ mensaje }}
            </span>
        </div>

        <div class="d-flex justify-content-center mt-4">
            <div class="d-flex col-md-2 mt-2 me-5">
                <label class="mt-1 me-3">Sigla</label>
                <input type="text" [(ngModel)]="sigla" placeholder="Sigla del aplicativo" class="form-control" formControlName="Sigla">
            </div>
            <div class="d-flex col-md-6 mt-2 me-5">
                <label class="mt-1 me-3">Url</label>
                <input type="text" [(ngModel)]="url" placeholder="url de acceso" class="form-control" formControlName="Url">
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <span *ngIf="siglaObligatorio" class="text-danger">
                {{ mensaje }}
            </span>
        </div>

        <div class="d-flex justify-content-center mt-4">
            <div class="d-flex col-md-3 me-3">
                <label class="azul-titulos fw-bold">Roles seleccionados</label>
            </div>
            <div class="d-flex col-md-1">
            </div>
            <div class="d-flex col-md-3">
                <label class="azul-titulos fw-bold">Roles disponibles</label>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="card col-md-3 mt-3 me-5 scroll-listas-2">
                <ul class="list-group">
                    <li class="list-group-item cursor" *ngFor="let item of list_roles_destino; let i = index;" value="{{ item.idRole }}" (click)="seleccionRolDestino($event, i)" [ngClass]="{'active': indiceRolDestino === item.idRole, 'deshabilitar': correcto == true}">
                        {{ item.displayName }}
                    </li>
                </ul>
            </div>
            <div class="mt-3 align-self-center flex-column">
                <div class="mb-3">
                    <a class="text-primary cursor" (click)="agregarRol()"><i class="fa-solid fa-circle-left fa-2x"></i></a>
                </div>
                <div class="mb-3">
                    <a class="text-primary cursor" (click)="quitarRol()"><i class="fa-solid fa-circle-right fa-2x"></i></a>
                </div>
            </div>
            <div class="card col-md-3 mt-3 ms-5 scroll-listas-2">
                <ul class="list-group">
                    <li class="list-group-item cursor" *ngFor="let item of list_roles_origen; let i = index;" value="{{ item.idRole }}" (click)="seleccionRolOrigen($event, i)" [ngClass]="{'active': indiceRolOrigen === item.idRole, 'deshabilitar': correcto == true}">
                        {{ item.displayName }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-4 mb-3">
            <div class="me-2">
                <button class="btn btn-primary" (click)="guardarAplicacion()">GUARDAR</button>
            </div>
            <div class="ms-2 me-2">
                <button class="btn btn-secondary" (click)="cancelar()">CANCELAR</button>
            </div>
        </div>

    </form>

</div>
